import Barracks from "./Barracks";

export default Barracks;
